module.exports = "https://ec-cstatic.akulaku.net/mall/mobile/_next/static/images/open_app-f2008972e47c4e15bfdacaf8f15e423f.gif";